<dx-box direction="col" width="100%" height="100%">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-scroll-view direction="both" width="100%" height="100%">
                <div class="contact-us-tile-view tile-container">
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-people-carry',
                                iconPlacement: 'top',
                                iconClass: 'cc-icon-aqua icon-big',
                                htmlText:
                                    'Having trouble finding something or need assistance and/or support, please find self-serve resources in &lt;u&gt;CiraHelp&lt;/u&gt;',
                                targetUrl: cirahelpUrl
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-bug',
                                iconPlacement: 'bottom',
                                iconClass: 'cc-icon-greenYellow icon-big',
                                htmlText:
                                    'I\'ve tried the self-help resources and need to raise a &lt;u&gt;request of a technical matter&lt;/u&gt; with the CiraNet application',
                                targetUrl: supportUrl
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-laptop-medical',
                                iconPlacement: 'top',
                                iconClass: 'cc-icon-orange icon-big',
                                htmlText:
                                    'Having trouble with your computer hardware or network connection? Please work with your infrastructure support team'
                            }
                        }"
                    ></ng-container>
                    <ng-container
                        [ngTemplateOutlet]="contactUsTile"
                        [ngTemplateOutletContext]="{
                            data: {
                                icon: 'fas fa-lightbulb',
                                iconPlacement: 'bottom',
                                iconClass: 'cc-icon-yellow icon-big',
                                htmlText:
                                    'Some of the greatest ideas have come from our users. Submit your ideas today. Requests are reviewed quarterly.',
                                targetUrl: ideaCenterUrl
                            }
                        }"
                    ></ng-container>
                </div>
            </dx-scroll-view>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate class="cc-text-center">
            <span>
                You can call us at
                <strong>
                    <a href="tel:{{ contactUsPhone }}">{{ contactUsPhoneDisplayText }}</a>
                </strong>
                or Email us at
                <strong>
                    <a href="mailto:{{ contactEmail }}">{{ contactEmail }}</a>
                </strong>
            </span>
        </div>
    </dxi-item>
</dx-box>

<ng-template #contactUsTile let-data="data">
    <div
        *ngIf="data.htmlText"
        class="contact-us-tile dx-theme-accent-as-background-color dx-theme-accent-as-border-color"
        [ngClass]="{
            'cc-hyperlink': !!data.targetUrl,
            'top-icon-tile': data.iconPlacement === 'top',
            'bottom-icon-tile': data.iconPlacement === 'bottom'
        }"
        (click)="onTileClick(data.targetUrl)"
    >
        <div *ngIf="data.iconPlacement === 'top'" class="icon-content top-content">
            <i [ngClass]="data.icon" class="{{ data.iconClass }}"></i>
        </div>
        <div class="text-content dx-theme-background-color-as-text-color">
            <span [innerHTML]="data.htmlText | ccSafeHtml"></span>
        </div>
        <div *ngIf="data.iconPlacement === 'bottom'" class="icon-content bottom-content">
            <i [ngClass]="data.icon" class="{{ data.iconClass }}"></i>
        </div>
    </div>
    <div class="contact-us-empty-tile" *ngIf="!data.htmlText"></div>
</ng-template>
